import React from 'react'

import { AllMessages, AutomatedMessagesByTrigger, Message, Route } from '../types'
import { Action, ActiveView, State } from './messageReducer'

interface Context {
  scid?: number
  state: State
  route: Route
  messages?: AllMessages
  automatedMessagesByTrigger?: AutomatedMessagesByTrigger
  filteredMessages?: AllMessages
  fetchMessage: () => void
  fetchMessageLoading: boolean
  dispatch: React.Dispatch<Action>
  activeView?: ActiveView
  updatePriorityOrder: ({ message, priority }: { message: Message; priority: number }) => Promise<void>
}

const ctx: Context = {
  fetchMessage: () => {},
  fetchMessageLoading: true,
  dispatch: () => {},
  route: 'one-time',
  updatePriorityOrder: async () => {},
  state: {
    hasError: false,
    currentPage: 0,
    pageSize: 25,
    isLoading: true,
    route: 'one-time',
  },
}

const OutreachMessageContext = React.createContext(ctx)

export default OutreachMessageContext
